import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const applyLeaveAdminAPI = async (leaveData: string) => {
	const url = `${API_URL}ApplyLeaveAdmin`;
	const requestData = {
		ApplyLeaveAdminToken: leaveData,
	};
	return makeApiCall(url, requestData, 'POST');
};

export const getAllEmployeesAdminAPI = async (organisationData: string) => {
	const url = `${API_URL}GetAllEmployeesForLeaveAdmin`;
	const requestData = {
		GetAllEmployeesForLeaveAdminToken: organisationData,
	};
	return makeApiCall(url, requestData, 'POST');
};
